import TextAreaInput from './TextAreaInput'

export default TextAreaInput



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/TextAreaInput/index.js